var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("credit-limit-modal"),
      _vm._v(" "),
      _c("unlock-pro-modal"),
      _vm._v(" "),
      _c("max-concurrent-limit-modal"),
      _vm._v(" "),
      _c("generic-error-modal"),
      _vm._v(" "),
      _c("job-failed-modal"),
      _vm._v(" "),
      _c("feedback-modal"),
      _vm._v(" "),
      _vm.creatorStudio.isMobile === false
        ? _c("BaseLayout", {
            scopedSlots: _vm._u(
              [
                {
                  key: "topbar",
                  fn: function () {
                    return [_c("router-view", { attrs: { name: "Topbar" } })]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-left",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "SidebarLeft" } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "main-canvas",
                  fn: function () {
                    return [_c("router-view")]
                  },
                  proxy: true,
                },
                {
                  key: "sidebar-right",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "SidebarRight" } }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              140264876
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.creatorStudio.isMobile === true
        ? _c("MobileLayout", {
            scopedSlots: _vm._u(
              [
                {
                  key: "main-canvas",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "MobileDefault" } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "mobile-secondary-navbar",
                  fn: function () {
                    return [
                      _c("router-view", {
                        attrs: { name: "MobileSecondaryNavbar" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "mobile-navbar",
                  fn: function () {
                    return [
                      _c("router-view", { attrs: { name: "MobileNavbar" } }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1958303328
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }